import React, { useContext } from "react";
import { Container, FilterChip, ChipContent, Label } from "./DeviceTabs.styles";
import { ApplicationContext } from "../../../components/ApplicationProvider";

export enum DeviceTab {
    Printers = "printers",
    Gateways = "gateways",
}

type DeviceTabsProps = {
    activeTab: DeviceTab;
    onChange: (tab: DeviceTab) => void;
    isCSE: boolean;
};

const DeviceTabs: React.FC<DeviceTabsProps> = ({ activeTab, onChange, isCSE }) => {
    const { t } = useContext(ApplicationContext);

    return (
        <Container>
            {!isCSE && (
                <FilterChip
                    active={activeTab === DeviceTab.Printers}
                    aria-pressed={activeTab === DeviceTab.Printers}
                    onClick={() => onChange(DeviceTab.Printers)}
                >
                    <ChipContent>
                        <Label>{t("devices.device_tabs.printers")}</Label>
                    </ChipContent>
                </FilterChip>
            )}
            <FilterChip
                active={activeTab === DeviceTab.Gateways}
                aria-pressed={activeTab === DeviceTab.Gateways}
                onClick={() => onChange(DeviceTab.Gateways)}
            >
                <ChipContent>
                    <Label>{t("devices.device_tabs.gateways")}</Label>
                </ChipContent>
            </FilterChip>
        </Container>
    );
};

export default DeviceTabs;
